<div class="filters row">
  <div class="r-form-group">
    <label class="title">{{'LIDS.ROULETTE' |translate}}</label>
    <p-dropdown [options]="filteredRoulettes" [(ngModel)]="selectedRoulette" optionLabel="label"
      placeholder="{{'LIDS.ALL_ROULETTES' |translate}}" [showClear]="true" (onClear)="selectRoulette()"
      (onChange)="selectRoulette()"></p-dropdown>
  </div>

  <div class="row">
    <div class="r-form-group">
      <label class="title">{{'LIDS.START_DATE' |translate}}</label>
      <p-calendar dateFormat="dd/mm/yy" [showButtonBar]="true" inputId="basic" [(ngModel)]="startDate"
        [clearButtonStyleClass]="'clear-button'" (onClearClick)="filterCreatedDate()" (onSelect)="filterCreatedDate()">
      </p-calendar>
    </div>
    <div class="r-form-group">
      <label class="title">{{'LIDS.END_DATE' |translate}}</label>
      <p-calendar dateFormat="dd/mm/yy" [showButtonBar]="true" inputId="basic" [(ngModel)]="endDate"
        [clearButtonStyleClass]="'clear-button'" (onClearClick)="filterCreatedDate()" (onSelect)="filterCreatedDate()"
        (onClickOutside)="filterCreatedDate()"></p-calendar>
    </div>
  </div>
  <div class="r-form-group">
    <label class="title">{{'LIDS.SEARCH' |translate}}</label>
    <input [(ngModel)]="freeSearch" type="text" pInputText size="50" placeholder="{{'LIDS.SEARCH_LID' |translate}}"
      (delayEvent)="filterfreeSearch()" delayEventName="onkeyup">
  </div>
<div class="r-form-group totalRecords">{{totalRecords}} {{'ROULETTE.LIDS'|translate}}</div>
  <app-atn-export-excel  [request]="request"[fileName]="'customers'"></app-atn-export-excel> 
</div>

<div class="table">
  <app-readonly-table #dt [columns]="columns" [selectionMode]="null" [itemsSource$]="lids$" [isFilterable]="false"
    (onViewDetails)="onOpenLidDetails($event)" dataKey="CustomerId" [paginator]="true" (onLoadData)="onLoadData($event)"
    [isLoadLazy]="true" [totalRecords]="totalRecords" [rowsPerPageOptions]="null">
  </app-readonly-table>
</div>
<p-dialog [(visible)]="viewLidDetails" class="dialog" [baseZIndex]="10000" [style]="{width: '608px', height:'720px'}"
    [draggable]="false" [resizable]="false"> 
     <app-lid-details-dialog *ngIf="viewLidDetails" [lidId]="lidId" [lidDetails]="lidDetails" (onCouponImplemented)="loadLids(); viewLidDetails=false"></app-lid-details-dialog>
</p-dialog>
